import getBaseUrl from "../helpers/getBaseUrl";
import inIframe from "../helpers/inframe";
import {blog} from "@/staticData/routesName/blog";
import Leita from "@/components/svg/nav/Leita";


import routesNames from '@/router/constants'

export default {
    baseUrl: getBaseUrl(),
    imageUrl: 'https://img.bilaskra.is',//getBaseUrl(),
    api: getBaseUrl() + '/api',
    app_version: '0.04',
    access_token: '',
    profile: {},
    status: null,
    dealerFilterData: [],
    dealerData: [],
    lib: {},
    favorites: {},
    carFilter: [],
    filter: null,
    selected_filters_count: 0,
    car_id: 0,
    popup: null,
    scrollTop: 0,
    resultCount: 0,
    car_data: null,
    scrollPositionPageOldCars: 0,
    scrollPositionPageDealers: 0,
    dataCarsLoadedFlag: false,
    dataCarLoadedFlag: false,
    onFilterBrandsFlag: true,
    isApp: inIframe() ? null : localStorage.getItem("app") == 1 ? 1 : 0,
    popUpHeaderMenu: false,
    newCarsPrice: [0, 20000000],
    scrollElem: window,
    selectedContactFormCheckbox: null,
    saveBtnMobileHide: true,
    dealerCarsTotalLoad: 0,
    showCarsInStock: false,
    /*oldCarsStartParams: {
        argerd: {
            mi: 1999,
            ma: 2022
        },
        ekinn: {
            mi: 0,
            ma: 300000
        },
        verd: {
            mi: 0,
            ma: 20000000
        },
        affinity: {
            min: 0,
            max: 700
        },
        towing_capacity: {
            min: 0,
            max: 3500
        }
    },*/
    /*newCarsStartParams: {
        affinity: {
            min: 0,
            max: 700
        },
        towing_capacity: {
            min: 0,
            max: 3500
        },
        engine:{
            min:0,
            max:5000
        },
        horse_power:{
            min:0,
            max:800
        }
    },*/
    pageLinks: [
        {
            link: routesNames.oldCars,
            name: "Notaðir bílar",
            components: ['OldCars', 'Car'],
            target: ['popup', 'mobile', 'desktop']
        },
        {
            link: routesNames.newCars,
            name: "Nýir bílar",
            components: ['DealersCars', 'DealerCar'],
            target: ['popup', 'mobile', 'desktop']
        },
        /*        {
                    link: "/kjarabilar",
                    name: "Kjarabílar",
                    components: ['CarsInStock', 'CarInStock'],
                    target: ['popup', 'mobile', 'desktop']
                },*/
        {
            link: '/',
            name: 'Leita',
            icon: 'Leita',
            components: ['DealersCars', 'OldCars'],
            target: ['appBottom']
        },
        {
            link: '/favorites',
            name: 'Eftirlæti',
            components: ['Favorites'],
            icon: 'Favorites',
            target: ['appBottom', 'popup']
        },
        {
            link: '/notifications',
            name: 'Vistuð leit',
            components: ['Notification'],
            icon: 'Notifications',
            target: ['appBottom', 'popup']
        },
         {
             link: blog,
             name: "Allt um bíla",
             components: ['Blog', 'ReynsluaksturSimplePost', 'Fréttir', 'Viðburðir', 'Reynsluakstur', 'FréttirSimplePost'],
             target: ['popup', 'mobile', 'desktop']
         },
        {
            link: "/about-project",
            name: "Um okkur",
            components: ['AboutProject'],
            target: ['popup', 'mobile', 'desktop']
        }
    ],
    OtherPageLink: [],
    showMobilePopUpMenu: false,
    sub: 0,
    notifications: {
        new_car: [],
        old_car: [],
        stock_car: [],
        lib: []
    },
    newBanner: false,
    showMenu:false,
    lastCarPageVisit:{},
    excludeFilterParams:['wbraid'],
    oldCarsLoadedCars: [],
    oldCarsPosition: 0,
    defaultShareImage:  'https://img.bilaskra.is/img/share2.png?'+ (new Date().getTime()),
    specialText: null,
    viewSiteLink: `${getBaseUrl()}/redirect/view-site?id=`,
    viewCarPdfLink : `${getBaseUrl()}/redirect/view-car-pdf?id=`,
    footerData: {},
    fbModuleAlert: null,
    isPrerender: window.prerender ? true : false
}